import { createPageReader } from '../createPageReader.jsx';
export default createPageReader('FLEX_OFFICE', 'contact');
